import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ToggleValues from '@shared/helpers/feature-toggles';
import { GatekeeperService } from '@shared/services';
import { FeatureToggle, IFeatureToggle } from '@store/reducers/feature/feature.reducer';
import { switchMap } from 'rxjs';

import { EnableFeatureToggles, GetAndSetAllFeatureToggles } from '../../actions';

@Injectable()
export class FeatureEffects {
  constructor(
    private actions$: Actions,
    private gateKeeperService: GatekeeperService,
  ) {}

  setToggles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetAndSetAllFeatureToggles),
      switchMap(() => {
        const featureToggles = Object.keys(FeatureToggle)
          .map((key) => ToggleValues[key])
          .filter((x) => !!x);
        const invertedToggleValues = Object.entries(ToggleValues).reduce((acc, [key, value]) => {
          acc[value] = key;
          return acc;
        }, {});
        return this.gateKeeperService.getGatekeeperMulti(featureToggles).pipe(
          switchMap((toggles: IFeatureToggle[]) => [
            EnableFeatureToggles({
              payload: toggles
                .filter((x) => x.enabled)
                .map((x) => FeatureToggle[invertedToggleValues[x.featureId]]),
            }),
          ]),
        );
      }),
    ),
  );
}
